import CryptoJS from 'crypto-js'

export function encrypt(toEncrypt: string, key: string): string {
  return CryptoJS.AES.encrypt(toEncrypt, key).toString()
}

export function decrypt(toDecrypt: string, key: string): string {
  return CryptoJS.AES.decrypt(toDecrypt, key).toString(CryptoJS.enc.Utf8)
}
